// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__upP1v","content":"styles_content__2YHTP","selectAll":"styles_selectAll__28Sy8"};